/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from "react";
import { createReactComponent } from "../../../adapter";
import { DividerApi } from "@a2ui/web_core/v0_9/basic_catalog";
import { LEAF_MARGIN } from "../utils";

export const Divider = createReactComponent(DividerApi, ({ props }) => {
  const isVertical = props.axis === "vertical";
  const style: React.CSSProperties = {
    margin: LEAF_MARGIN,
    border: "none",
    backgroundColor: "#ccc",
  };

  if (isVertical) {
    style.width = "1px";
    style.height = "100%";
  } else {
    style.width = "100%";
    style.height = "1px";
  }

  return <div style={style} />;
});
